import { gql } from "@apollo/client";

export const GET_RECOMMENDATIONS_QUERY = gql`
  query GET_RECOMMENDATIONS_QUERY {
    getRecommendations {
      _id
      name
      description
      render {
        container
        items
      }

      items {
        edges {
          node {
            _id
            name
            description
            color
            type
            img
            internalLink
            externalLink
            company {
              _id
              fantasyName
            }
          }
        }
      }
    }
  }
`;
